import { CheckmarkIcon } from "styles/icons";
import { trackClickEvent, buildTrackingBasedId } from "utils/trackingUtils";
import Link from "next/link";
import {
  ChakraFlex as Flex,
  ChakraBox as Box,
  ChakraHeading as Heading,
  ChakraText as Text,
  ChakraButton as Button,
} from "@airhelp/react-ui-components";
import { bgUrl } from "./CTA.config";
import type { CTAProps } from "./CTA.d";

const CTA = ({ text, buttonText, buttonHref = "/404", checkboxes, gtmSection, gtmElement }: CTAProps) => (
  <Flex
    px={6}
    py={5}
    bg="primary.900"
    w="full"
    rounded="lg"
    color="white"
    bgImage={bgUrl}
    bgRepeat="no-repeat"
    bgPosition="right"
    bgSize="auto 100%"
  >
    <Box width="100%">
      <Heading color="inherit" variant="h3" as="h3" pr={{ md: 6 }}>
        {text}
      </Heading>
      <Link href={buttonHref}>
        <Button
          id={buildTrackingBasedId(gtmSection, gtmElement, "mobile")}
          variant="subtle"
          py={3}
          size="s"
          display={{ md: "none" }}
          mt={6}
          width="full"
          onClick={() => trackClickEvent(gtmSection, gtmElement)}
        >
          {buttonText}
        </Button>
      </Link>
      {checkboxes && (
        <Flex mt={{ base: 6, md: 4 }}>
          {checkboxes.map((checkbox) => (
            <Text mr={10} color="inherit" fontSize="sm" key={checkbox}>
              <CheckmarkIcon color="brand.blue" mr={1} mt={-1} /> {checkbox}
            </Text>
          ))}
        </Flex>
      )}
    </Box>
    <Box display={{ base: "none", md: "initial" }}>
      <Link href={buttonHref}>
        <Button
          id={buildTrackingBasedId(gtmSection, gtmElement)}
          variant="subtle"
          py={3}
          size="s"
          minW="fit-content"
          whiteSpace="nowrap"
          as={Button}
          onClick={() => trackClickEvent(gtmSection, gtmElement)}
        >
          {buttonText}
        </Button>
      </Link>
    </Box>
  </Flex>
);

export default CTA;
